<template >
  <div class="container-fluid" v-if="school">
    <!-- DataTales Example -->
    <div class="card my-4">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h6 class="m-0 font-weight-bold text-primary">
              Ангиуд - {{ school.currentYear }}
            </h6>
            <p>
              <span style="color: black">Сурагчдын тоо: </span>
              <span class="font-weight-bold">{{ countStudents }}</span>
            </p>
            <p>
              <span class="">Нийт бүлгийн тоо: </span>
              <span class="font-weight-bold">{{ countOfPrograms }}, </span>
              <span class="text-danger">багшгүй бүлгийн тоо: </span>
              <span class="font-weight-bold">{{ countOfNoTeachers }}, </span>
              <span class="">багштай бүлгийн тоо: </span>
              <span class="font-weight-bold">{{ countOfTeachers }}, </span>
            </p>
          </div>
          <div class="col col-auto">
            <div class="col-auto">
              <label class="mr-4">
                <input
                  type="checkbox"
                  style="transform: scale(1.4)"
                  class="mr-2"
                  v-model="changeTeacher"
                />
                <span class="" style="font-weight: normal">Багш оруулаx</span>
              </label>
              <!-- <button
                class="btn btn-lg btn-danger mr-2 btn-sm"
                @click="
                  $router.push({
                    name: 'XDepartments',
                    params: { schoolId: school.id },
                  })
                "
              >
                2020 - Ангиуд
              </button> -->
              <!-- <div @click="$router.push({ 'name':'ILessonAdd' , params:{ schoolId: schoolId, setTeacher: true }})" class="btn btn-danger btn-sm mr-2">Хичээл нэмэх</div> -->
              <!-- <div @click="$router.push({ 'name':'ILessonAddGroup' , params:{ schoolId: schoolId, setTeacher: true }})" class="btn btn-danger btn-sm">Хичээл багцалж нэмэх</div> -->
            </div>
          </div>
        </div>
      </div>
      <div
        class="card-body"
        v-if="departments != null && departments.length > 0"
      >
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th width="1%">№</th>
                <th>Нэр</th>
                <th title="Бүлгийн тоо">Б.тоо</th>
                <th>С.тоо</th>
                <th colspan="10">Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(dep, index) in departments" v-bind:key="dep.id">
                <td>{{ index + 1 }}</td>
                <td style="width: 6%" class="text-primary">
                  {{ dep.name }} анги
                </td>
                <td
                  style="width: 1%"
                  v-if="dep.programs != undefined && dep.programs != null"
                >
                  {{ dep.programs.length }}
                </td>
                <td style="width: 1%" class="text-primary">{{ dep.numberOfStudents }}</td>
                <td
                  class="schedule-cell"
                  v-for="(prog, pindex) in dep.programs"
                  :key="pindex"
                  style="width: 14%; cursor: pointer"
                  @click="_clickedCell(dep, prog)"
                >
                  <span style="color: black">{{
                    prog.name.toUpperCase()
                  }}</span>
                  (<span class="text-primary">{{ prog.numberOfStudents }}</span>)
                  <small v-if="prog.teacherData">
                    <span
                      v-if="
                        prog.teacherData.lastname &&
                        prog.teacherData.lastname.length > 0
                      "
                    >
                      {{ prog.teacherData.lastname[0].toUpperCase() }}.
                    </span>

                    <span style="color:black">{{ prog.teacherData.name }}</span></small
                  >
                  <small v-else class="text-danger">Багшгүй</small>
                </td>
                <!-- <td>{{topic.createdAt | formatDate}}</td> -->

                <!-- <td>
                  <button class="btn btn-primary btn-sm" @click="goDetail(dep)">
                    xараx
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="alert alert-warning">
        Одоогоор Ангиийн мэдээлэл ороогүй байна.
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="proModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="proModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="proModalLabel">Бүлэг нэмэх</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="selectedProgram != null">
            <form class="user">
              <div class="row" v-if="teachers && teachers.length > 0">
                <div class="col form-group">
                  <label for="exampleFormControlSelect1"
                    >Анги удирдсан багш:</label
                  >
                  <select
                    class="form-control"
                    v-model="selectedProgram.teacher"
                  >
                    <option
                      v-for="teacher in teachers"
                      v-bind:key="'teacher-' + teacher.id"
                      v-bind:value="teacher.ref"
                    >
                      {{ teacher.name }} - {{ teacher.code }} -
                      {{ teacher.email }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label>Онлайн уулзалтын линк</label>
                <textarea
                  rows="1"
                  v-model.trim="selectedProgram.onlineroom"
                  class="form-control"
                  placeholder="Онлайн уулзалтын линк"
                />
              </div>
              <div class="form-group">
                <label>Бүлэг дэлгэрэнгүй</label>
                <textarea
                  rows="5"
                  v-model.trim="selectedProgram.description"
                  class="form-control"
                  placeholder="Бүлэг дэлгэрэнгүй оруулна уу"
                />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
            <button
              @click="_saveEditing"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >
              Xадгалаx
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "SDepartments",
  data() {
    return {
      school: null,
      department: {
        name: null,
        shortName: null,
        description: null,
        startYear: 2020,
      },
      departments: [],
      countOfPrograms: 0,
      changeTeacher: null,
      selectedProgram: null,
      teachers: null,
    };
  },

  methods: {
    _saveEditing() {
      console.log(this.selectedProgram);
      const newUpdate = {
        onlineroom: this.selectedProgram.onlineroom,
        teacher: this.selectedProgram.teacher,
        description: this.selectedProgram.description,
      };
      this.selectedProgram.ref.update(newUpdate),
        then(() => {
          alert("Амжиттай xадгалагдлаа!");
        });
    },
    _clickedCell(dep, prog) {
      if (this.changeTeacher) {
        this.selectedProgram = Object.assign({}, prog);
        $("#proModal").modal("toggle");
      } else {
        this.$router.push({
          name: "IGroupStudents",
          params: {
            schoolId: this.school.id,
            departmentId: dep.id,
            programId: prog.id,
          },
        });
      }
    },
    _calStudents() {
      this.departments.forEach((dep) => {
        dep.programs.forEach(async (progr) => {
          var studentRef = await this.school.ref
            .collection("students")
            .where("program", "==", progr.ref)
            .get();
          if (!studentRef.empty) {
            progr.ref.update({ numberOfStudents: studentRef.size });
          } else {
            console.log(studentRef.size);
          }
        });
      });
    },
    async _initData() {
      var schoolRef = await fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get();

      if (schoolRef.exists) {
        console.log(schoolRef.id);
        let school = schoolRef.data();
        school.id = schoolRef.id;
        school.ref = schoolRef.ref;
        this.school = school;
      }
      fb.db
        .collection("schools/" + this.schoolId + "/teachers")
        .orderBy("name", "asc")
        .get()
        .then((docs) => {
          this.teachers = [];
          docs.docs.forEach((doc) => {
            let teacher = doc.data();
            teacher.id = doc.id;
            teacher.ref = doc.ref;
            this.teachers.push(teacher);
          });
        });

      this._getDepartments(this.school.currentYear);
    },
    _getDepartments(startYear) {
      console.log(startYear);
      if (this.school != null) {
        fb.db
          .collection("schools")
          .doc(this.schoolId)
          .collection("departments")
          .where("startYear", "==", startYear)
          .orderBy("createdAt", "desc")
          .onSnapshot((querySnapshot) => {
            this.departments = [];
            querySnapshot.forEach((doc) => {
              this.countOfPrograms = 0;
              let dep = doc.data();
              dep.id = doc.id;
              dep.ref = doc.ref;
              dep.ref
                .collection("programs")
                .orderBy("name", "asc")
                .onSnapshot((querySnapshot) => {
                  dep.programs = [];
                  dep.numberOfStudents = 0;
                  querySnapshot.forEach(async (doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    let prog = doc.data();
                    prog.id = doc.id;
                    prog.ref = doc.ref;
                    prog.teacherData = null;
                    if (prog.teacher) {
                      prog.teacher.get().then((tdoc) => {
                        if (tdoc.exists) {
                          prog.teacherData = tdoc.data();
                        }
                      });
                    }
                    dep.numberOfStudents =
                      dep.numberOfStudents + prog.numberOfStudents;
                    dep.programs.push(prog);
                    this.countOfPrograms = this.countOfPrograms + 1;
                  });
                  dep.ref.update({ numberOfStudents: dep.numberOfStudents });
                  this.departments.push(dep);
                });

              // fb.db.collection("schools/"+this.schoolId+"/students").where("department", "==", doc.ref).get().then(stdocs=>{
              //   if(stdocs && !stdocs.empty){
              //     doc.ref.update({numberOfStudents: stdocs.size});
              //   }
              // });
            });
          });
      }
    },
    goDetail(dep) {
      this.$router.push({
        name: "DepartmentDetail",
        params: { schoolId: this.schoolId, departmentId: dep.id },
      });
    },
    goDetailLesson(dep) {
      this.$router.push({
        name: "SCategories",
        params: { schoolId: this.schoolId, departmentId: dep.id },
      });
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    countStudents: function (val) {
      var count = 0;
      this.departments.forEach((dep) => {
        count = count + dep.numberOfStudents;
      });
      return count;
    },
    countOfTeachers() {
      var count = 0;
      this.departments.forEach((dep) => {
        dep.programs.forEach((prog) => {
          if (prog.teacher) {
            count = count + 1;
          }
        });
      });
      return count;
    },
    countOfNoTeachers() {
      var noteacher = 0;
      this.departments.forEach((dep) => {
        dep.programs.forEach((prog) => {
          if (prog.teacher) {
          } else {
            noteacher = noteacher + 1;
          }
        });
      });
      return noteacher;
    },
  },
  props: {
    schoolId: {
      required: true,
    },
  },
  created() {
    var _this = this;
    if (this.schoolId != null && this.schoolId != "") this._initData();
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    },
  },
};
</script>

